import { Copy } from 'lucide-react';

import { copyToClipboard } from '../lib/clipboard';
import { Button } from '../primitives/button';

type Props = {
    urlToCopy: string;
};

export function UnsupportedBrowser({ urlToCopy }: Props) {
    const handleCopy = () => {
        void copyToClipboard(urlToCopy);
    };

    return (
        <div className="flex-1 grid grid-cols-[minmax(0,1fr)_minmax(auto,1fr)] overflow-hidden">
            <div />
            <div className="flex flex-col gap-7.5 items-start justify-center max-w-127 min-w-80 xs:min-w-127 px-2.5">
                <div className="flex flex-col gap-4 items-start w-full">
                    <h1 className="text-5xl font-bold leading-12 text-foreground">
                        Nesso isn’t available on this browser
                    </h1>
                    <p className="text-2xl font-medium leading-8 text-muted-foreground">
                        To ensure a stable and secure experience, switch to Chrome or Safari.
                    </p>
                </div>
                <Button size="lg" onClick={handleCopy}>
                    <Copy className="size-4" />
                    Copy Nesso URL
                </Button>
            </div>
        </div>
    );
}
